import bodymovin from 'bodymovin';

export default function loadAnimation(element){

   const animation = bodymovin.loadAnimation({
      name : element,
      container: document.getElementById(element),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: `${baseUrl}js/bodymovin/${element}.json`
   });

   /**
   *  On retourne l'animation pour pouvoir modifier ses propriétés.
   **/
   return animation;

};
